import { createAction } from '@reduxjs/toolkit';
import { MyPeopleEvalDataFilters } from '../interfaces/MyPeopleEvalsDataFilters';
import { StartEvalData } from '@modules/EvaluationModule/interfaces/StartEvalData';

export const getMyPeopleEvalData = createAction<MyPeopleEvalDataFilters>('myPeopleEvalPage/getMyPeopleEvalData');
export const setMyPeopleEvalDataLoading = createAction<void>('myPeopleEvalPage/setMyPeopleEvalDataLoading');
export const setSelectedEvalsAction = createAction<StartEvalData>('myPeopleEvalPage/setSelectedEvalsAction');
export const getAllLocationsData = createAction('myPeopleEvalPage/getAllLocationsData');
export const setManagersIds = createAction<string[]>('myPeopleEvalPage/setManagersIds');
export const setMembersIds = createAction<string[]>('myPeopleEvalPage/setMembersIds');
